import BootOption, { BootOption as BootOptionType, init as bootOptionInit } from './BootOption';
import Ch, { Ch as ChType, init as chInit } from './Ch';
import ChDetail, { ChDetail as ChDetailType } from './ChDetail';
import Post, { Post as PostType, init as postInit } from './Post';
import Rank, { Rank as RankType, init as rankInit } from './Rank';
import ChConfig, { ChConfig as ChConfigType, init as chConfigInit } from './ChConfig';

import {
  TuneProjection as TuneProjectionType,
  TuneSubscribeOption as TuneSubscribeOptionType,
  tuneProjectionInit,
  tuneSubscribeOptionInit,
} from '../talkn-config';

// トラッキング型（re-export）
export * from './tracking';

export type Types = {
  BootOption: BootOptionType;
  Ch: ChType;
  ChDetail: ChDetailType;
  Post: PostType;
  Rank: RankType;
  ChTree: ChConfigType;
  TuneSubscribeOption: TuneSubscribeOptionType;
  TuneProjection: TuneProjectionType;
};

export const inits = {
  bootOption: bootOptionInit,
  ch: chInit,
  post: postInit,
  rank: rankInit,
  chTree: chConfigInit,
  projection: tuneProjectionInit,
  tuneOption: tuneSubscribeOptionInit,
};

export default {
  BootOption,
  Ch,
  ChDetail,
  Rank,
  Post,
  ChConfig,
};
